<template>
    <div class="searchWrap clearfix" :class="logo === false ? 'logoHideState' : ''">
        <!--<div class="left fl" @click="gotoHome()" :class="subheading ? 'subheading' : ''" title="首页" v-show="logo===false ? false : true">{{ subheading }}</div>-->
        <div class="left fl" @click="gotoHome()" :class="subheading ? 'subheading' : ''" v-show="logo===false ? false : true">浙江温周</div>
        <div class="right fr pr" >
            <el-row class="demo-autocomplete" style="position: absolute;top: 50%;margin-top: -16px;height:32px;">
                <el-col :span="12">
                    <el-autocomplete
                    style="width: 475px;margin-left: 120px;border-raiuds: 0;height: 32px;"
                    class="inline-input"
                    v-model="state2"
                    :fetch-suggestions="querySearch"
                    :placeholder="title"
                    :trigger-on-focus="false"
                    @select="handleSelect"
                    >
                    </el-autocomplete>
                </el-col>
            </el-row>
            <div class="serarchButton" @click="search();sendMsg()"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['title','subheading','logo'],
    data() {
        return {
            commdity: [],
            state2: this.$store.state.searchText
        }
    },
    methods: {
        querySearch(queryString, cb) {
            var commdity = this.commdity;
            var results = queryString ? commdity.filter(this.createFilter(queryString)) : commdity;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },
        createFilter(queryString) {
            return (restaurant) => {
                return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) !== -1);
            };
        },
        loadAll() {
            return [
                { "value": "儿童回春颗粒(景优同)"},
            ]
        },
        handleSelect(item) {
            console.log(item)
        },
        search() {
            this.$router.push({path:'/drugCategory',query:{search:this.state2}})
            this.$store.commit('set_search',this.state2)
        },
        sendMsg() {
            this.$emit('func')
        },
        gotoHome() {
            this.$router.push('/')
        }
    },
    mounted() {
      this.commdity = this.loadAll();
    }
}
</script>
<style scoped>
    .searchWrap{
        height: 120px;
    }
    /*.searchWrap .left{
        width: 260px;
        height: 100%;
        background: url('../../assets/images/views/logo.png') left center no-repeat;
        background-size: 70%;
        cursor: pointer;
    }*/
    .searchWrap .left{
        width: 260px;
        height: 100%;
        line-height: 120px;
        font-size: 32px;
        background-size: 70%;
        cursor: pointer;
    }
    .searchWrap .subheading{
        width: 605px;
        line-height: 120px;
        text-indent: 230px;
        font-size: 25px;
        color: #727272;
        background-position: left center;
        background-size: 213px;;
    }
    .searchWrap .right{
        height: 100%;
        line-height: 100%;
        width: 595px;
    }
    .serarchButton{
        position: absolute;
        width: 70px;
        cursor: pointer;
        height: 35px;
        background: url('../../assets/images/icon/searchIcon.png') center center no-repeat #1d90d0;
        top: 50%;
        margin-top: -16px;
        right: 0
    }
    .logoHideState{
        height: 35px;
        line-height: 35px;
        padding: 8px 0;
    }
    .logoHideState .right{
        width: 474px;
    }
    .logoHideState .el-autocomplete{
        margin-left: 0!important;
    }
</style>

<style>
    .searchWrap .el-input__inner{
        border-radius: 0;
        height: 32px;
        border-color: #1d90d0;
        border-width: 2px;
    }
</style>